import {
	defaultTranslationFinderFactory,
	Locale,
	Localizable,
	localizableFromLocalizationTreeMap,
	LocalizationKeyTree
} from "@com.mgmtp.a12.utils/utils-localization/lib/main";

import { RESOURCE_KEYS } from "./keys";
import { DEFAULT_TRANSLATIONS } from "./resources";

const KNOWN_LOCALIZABLE_MAP: Record<string, Omit<Localizable, "args">> = {};

const queue: LocalizationKeyTree[] = [RESOURCE_KEYS];
for (let entry = queue.shift(); entry !== undefined; entry = queue.shift()) {
	for (const node of Object.values(entry)) {
		if (typeof node === "string") {
			KNOWN_LOCALIZABLE_MAP[node] = localizableFromLocalizationTreeMap(node, DEFAULT_TRANSLATIONS);
		} else {
			queue.push(node);
		}
	}
}

export const translationSource = defaultTranslationFinderFactory(function textResolver(localizableKey, locale) {
	// NOTE: Precompute localizables in a flat map is about 75% faster then A12 default
	return KNOWN_LOCALIZABLE_MAP[localizableKey]?.defaults?.[Locale.toString(locale)];
});
